export default function () {
    $('.morecontent-button').on('click', (e) => {
        e.preventDefault();
        const $moreContent = $(e.target).closest('.module-morecontent');
        const $toggleButton = $moreContent.find('.morecontent-button');
        const $content = $moreContent.find('.morecontent-content');

        $toggleButton.find('a.link').toggleClass('close-content');
        $content.slideToggle(500, 'swing');
    });
}
